import { useParams, useNavigate, useLocation } from 'react-router-dom';

export function withRouter(Component) {
  return function Wrapper(props) {
    const params = useParams();
    const navigate = useNavigate();
    const location = useLocation();
    return (
      <Component
        {...props}
        params={params}
        navigate={navigate}
        location={location}
        match={{ params, url: location.pathname }}
      />
    );
  };
}
